var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    typography = _ref.typography,
    colors = _ref.colors,
    breakpoints = _ref.breakpoints;
  return {
    rootPadding: spacing.small,
    wrapperMargin: spacing.small,
    metricWrapperPadding: spacing.large,
    phoneBreakPoint: "max-width: ".concat(breakpoints.medium),
    tabletBreakPoint: "max-width: ".concat(breakpoints.large)
  };
};
export default generateComponentTheme;